// Currently we're only caring about pages that might have bidding capability
const pageNames = {
    '/c/': 'Category Page',
    '/catalog/': 'Catalog Page',
    '/catalog/search': 'Auction Calendar',
    '/console/': 'Bidding Console',
    '/dashboard/followed-auctioneers': 'My Followed Auctioneers',
    '/dashboard/my-auctions': 'My Auctions',
    '/dashboard/my-bids': 'My Bids',
    '/dashboard/saved-items': 'My Saved Items',
    '/dashboard/search-and-alerts': 'My Saved Search Results',
    '/featured/': 'Collection Page',
    '/item/': 'Item Page',
    '/recent': 'Recent Items Page',
    '/recommended': 'Recommended Items Page',
    '/search/': 'Search Page',
};

export default (path: string = '') => {
    // the only page that could potentially be confused
    if (path === '/') {
        return 'Home Page';
    } else if (path.includes('/catalog/search')) {
        return pageNames['/catalog/search'];
    } else if (path.includes('/catalog/')) {
        return pageNames['/catalog/'];
    }

    let pageName = '';
    Object.keys(pageNames).forEach((partialPath) => {
        if (path.includes(partialPath)) {
            pageName = pageNames[partialPath];
        }
    });

    return pageName;
};
